module.exports = __webpack_public_path__ + "static/media/current-period-line-purple.4c70728c.svg";